<template>
  <div :class="{ disabled, active }" :title="title">
    <template v-if="icon">
      <i class="bx max-w-full max-h-full" :class="icon" v-if="typeof icon === 'string'" />
      <component :is="icon" v-else class="max-w-full max-h-full" />
    </template>
    <slot v-else />
  </div>
</template>

<script lang="ts" setup>
import { capitalize, computed, type Component } from 'vue';

function replaceUppercaseWithSpace(str: string) {
  return str.replace(/[A-Z]/g, ' $&');
}

const props = defineProps<{
  icon?: string | Component;
  group?: string;
  value?: string;
  active?: boolean;
  disabled?: boolean;
}>();

const title = computed(() => capitalize(replaceUppercaseWithSpace(props.value || '')));
</script>

<style scoped>
.disabled {
  pointer-events: none;
  color: gray;
}
</style>
